import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent<T> {
  @Input() label: string;

  @Input() options: T[];

  @Input() selectedValue: T | number | T[];

  @Input() selectClass: string = '';

  @Input() selectPlaceholder: string = '';

  @Input() multiSelect = false;

  @Input() isCustom: string;

  @Input() customDisplayOption: string;

  @Input() isAddTag: boolean = false;

  @Input() clearable: boolean = false;

  @Output() selectedValueChange = new EventEmitter<any>();

  @Output() searchEvent = new EventEmitter<any>();

  @Output() focusEvent = new EventEmitter<any>();

  onSelectChange(value: any) {
    this.selectedValue = value;
    this.selectedValueChange.emit(value);  
  }

  displayOption(option: T): string {
    return option['name'] || option['title'] || option.toString();
  }

  formatOption(option: T, format: string): string {
    const parts = format.split(',').map(part => part.trim());
    return parts.map(part => option[part]).join(', ');
  }

  onSearch(event: any) {
    this.searchEvent.emit(event);
  }

  onFocus(event: any) {
    this.focusEvent.emit(event);
  }
}
